import { FC } from 'react';
import { useSelector } from 'react-redux';

import { selectIsSpecialProjectAdfoxBannerVisible } from 'shared/selectors/results/selectIsSpecialProjectAdfoxBannerVisible';
import { selectSpecialPromoBuilderOffers } from 'shared/selectors/results/selectSpecialPromoBuilderOffers';

import { SpecialProjectBanner } from '../AdfoxBanner';

import { SpecialProjectCarousel } from './internal/components/SpecialProjectCarousel';

export const SpecialProject: FC = () => {
  const specialPromoBuilderOffers = useSelector(selectSpecialPromoBuilderOffers);
  const isSpecialProjectAdfoxBannerVisible = useSelector(selectIsSpecialProjectAdfoxBannerVisible);

  if (isSpecialProjectAdfoxBannerVisible) {
    return <SpecialProjectBanner />;
  }

  if (specialPromoBuilderOffers) {
    return (
      <SpecialProjectCarousel
        allOffersUrl={specialPromoBuilderOffers.allOffersUrl}
        builder={specialPromoBuilderOffers.builder}
        offers={specialPromoBuilderOffers.offers}
      />
    );
  }

  return null;
};
